module.exports = __webpack_public_path__ + "img/starbucks.e6d327e2.png";